<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.885 11.4334L17.8144 12.3986C18.0619 12.5224 18.0619 12.8756 17.8144 12.9994L9.30035 17.2575C9.20707 17.304 9.10424 17.3283 8.99998 17.3283C8.89572 17.3283 8.79289 17.304 8.6996 17.2575L0.185604 12.9994C0.129986 12.9713 0.0832437 12.9284 0.0505847 12.8754C0.0179257 12.8223 0.00063288 12.7613 0.00063288 12.699C0.00063288 12.6367 0.0179257 12.5756 0.0505847 12.5226C0.0832437 12.4696 0.129986 12.4266 0.185604 12.3986L2.1161 11.4334L8.09773 14.4247C8.66585 14.7082 9.33523 14.7082 9.90223 14.4247L15.8839 11.4322L15.885 11.4334ZM8.6996 0.0708643C8.79289 0.0243148 8.89572 8.39233e-05 8.99998 8.39233e-05C9.10424 8.39233e-05 9.20707 0.0243148 9.30035 0.0708643L17.8144 4.32786C17.8699 4.35608 17.9166 4.39913 17.9492 4.45225C17.9818 4.50537 17.9991 4.56648 17.9991 4.6288C17.9991 4.69113 17.9818 4.75224 17.9492 4.80535C17.9166 4.85847 17.8699 4.90153 17.8144 4.92974L9.30035 9.18561C9.20707 9.23216 9.10424 9.25639 8.99998 9.25639C8.89572 9.25639 8.79289 9.23216 8.6996 9.18561L0.185604 4.92974C0.129691 4.90182 0.0826628 4.85887 0.0497929 4.80572C0.016923 4.75256 -0.000488281 4.6913 -0.000488281 4.6288C-0.000488281 4.5663 0.016923 4.50504 0.0497929 4.45189C0.0826628 4.39873 0.129691 4.35579 0.185604 4.32786L8.6996 0.0708643Z"
      fill="#B7BDCD"
    />
    <path
      d="M15.8848 7.39811L17.8142 8.36336C18.0617 8.48711 18.0617 8.84036 17.8142 8.96411L9.30021 13.2211C9.20692 13.2677 9.10409 13.2919 8.99983 13.2919C8.89558 13.2919 8.79275 13.2677 8.69946 13.2211L0.18546 8.96411C0.129842 8.93607 0.0830991 8.89315 0.0504401 8.84011C0.0177811 8.78708 0.000488281 8.72602 0.000488281 8.66373C0.000488281 8.60145 0.0177811 8.54039 0.0504401 8.48735C0.0830991 8.43432 0.129842 8.39139 0.18546 8.36336L2.11596 7.39811L8.09758 10.3895C8.66571 10.673 9.33508 10.673 9.90208 10.3895L15.8837 7.39811H15.8848Z"
      fill="#B7BDCD"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
